import React from 'react';
import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import './App.css';
import { Person } from '@mui/icons-material';
import moment from 'moment';

const allStatus = [
  {
    id: '1',
    name: 'Iniciada'
  },
  {
    id: '2',
    name: 'Referenciada'
  },
  {
    id: '3',
    name: 'Revisada'
  },
  {
    id: '4',
    name: 'Priorizada'
  },
  {
    id: '5',
    name: 'Agendada'
  },
  {
    id: '6',
    name: 'Atendida'
  },
  {
    id: '7',
    name: 'Cerrada'
  }
]
 
function Result({ response }) {
  console.log(response);
  const validateStatus = (id) => {
    console.log(response.serviceRequests)
    return response.serviceRequests.some((estado) => estado.id === id);
  }

  const getDate = (id) => {
    const status = response.serviceRequests.find((estado) => estado.id === id)

    if (!status) {
      return '-'
    }

    return moment(status.lastUpdated).format('DD/MM/YYYY HH:mm:ss');
  }

  return (
    <Container className="page">
      <h2 className="title">
        Detalle Interconsulta
      </h2>
      
      <div className="patientContainer section">
        <h3 className="subtitle">
          <Person/> <span>Datos de paciente</span>
        </h3>
        <p><b>Nombre: </b>{response.patient.name}</p>
        <p><b>RUT: </b>{response.patient.rut}</p>
        <p><b>Fecha de nacimiento: </b>{response.patient.birthDate ? moment(response.patient.birthDate).format('DD/MM/YYYY') : 'Desconocida'}</p>
      </div>
      <div className="section">
        <h3 className="subtitle">
          Estados Interconsulta
        </h3>
        <p><b>Estado Actual: </b> {response.serviceRequests[0].estadoInterconsulta}</p>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center" colSpan={3}>Estado</TableCell>
                <TableCell align="center">Fecha actualización</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allStatus.map((estado, index) => (
                <TableRow
                  key={estado.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {estado.id}
                  </TableCell>
                  <TableCell>{estado.name}</TableCell>
                  <TableCell align="center">
                    {
                      validateStatus(estado.id) ? (
                        <Chip label="OK" className='statusSuccess'/>
                      ) : (
                        <Chip label="Pendiente" className='statusPending'/>
                      )
                    }
                  </TableCell>
                  <TableCell align="center">{getDate(estado.id)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Container>
  );
}

export default Result;
